import { IUser } from '../../api/base/Auth/types';
import { TRequest } from 'src/store/helpers';
import { useEffect, useState } from 'react';
import { useResponseFormHandler } from '../../utils/hooks/useResponseFormHandler';
import { SUCCESS_STATUS } from '../../utils/types/statuses';
import { getUserHomePage } from '../../utils/helpers';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';

interface IUseResponseAuthModel {
  user: IUser;
  request: TRequest;
  onSuccess?: any;
}

type TUseResponseAuth = (data: IUseResponseAuthModel) => any;

export const useResponseAuth: TUseResponseAuth = ({
  user,
  request,
  onSuccess,
}) => {
  const [msModalVisible, setMsModalVisibility] = useState(false);
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  useResponseFormHandler({ storeError: request.error });

  useEffect(() => {
    if (request.status === SUCCESS_STATUS) {
      if (onSuccess) {
        onSuccess();
      }
      setMsModalVisibility(false);
      history.push(getUserHomePage(user!));
    } else if (request?.error?.statusCode === 418) {
      setMsModalVisibility(true);
    } else if (request?.error?.statusCode === 403) {
      enqueueSnackbar('Sorry, your account was locked by admin', {
        variant: 'warning',
      });
    }
  }, [history, dispatch, request, user, onSuccess, enqueueSnackbar]);

  return {
    msModalVisible,
    setMsModalVisibility,
  };
};
